<template>
    <div class="hero">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <img class="hero-image" src="../assets/header-logo-experiment.png" />
        <div class="greeting-container">
          <div class="sign-in form-container">
            <h1 class="form-title">Sign in</h1>
            <div class="md-layout-item">
              <md-field>
                <label for="first-name">Username</label>
                <md-input name="username" id="username" v-model="form.username" :disabled="sending" />
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="first-name">Password</label>
                <md-input name="password" id="password" type="password" v-model="form.password" :disabled="sending" />
              </md-field>
              <span class="md-error" style="color: red;" v-if="errors">Wrong user name or password.</span>
            </div>
            <md-button
              type="submit"
              class="call-to-action"
              :disabled="sending"
              @click="signIn()"
              >Sign In</md-button>
          </div>
          <div class="vertical-divide">
            <div class="divider-content">OR</div>
          </div>
          <div class="sign-up form-container">
            <h1 class="form-title">Sign up</h1>
            <h2>Revolutionizing the legal services marketplace</h2>
            <p>Let's get started!<br/>What kind of user are you?</p>
            <div class="signup-actions">
              <router-link to="/lawyer-signup">
                <md-button>Lawyer</md-button>
              </router-link>
              <router-link to="/client-signup">
                <md-button>Client</md-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<style lang="scss" scoped>
$small-mobile-size: 330px;
$mobile-size: 700px;
$desktop-size: 701px;

.hero {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100%;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: $mobile-size) {
    &::before {
      background-image: none;
    }
  }

  @media screen and (min-width: $desktop-size) {
    &::before {
      background-image: url('../assets/handshake-graphic.png');
      background-repeat: no-repeat;
      background-position: center top;
      background-size: cover;
      content: '';
      height: 100%;
      left: 0;
      position: fixed;
      top: 0;
      width: 100%;
      will-change: transform;
      z-index: -1;
    }
  }
    .hero-overlay {
      position: absolute;
      top: 0;
      height: 100%;
      width: 100%;
      background: linear-gradient(163deg,
      rgba(121,221,255,.8) 0%,
      rgba(96,162,255,.8) 55%,
      rgba(73,108,255,.8) 80%,
      rgba(50,53,255,.8) 100%);
      z-index: 0;
    }
}

.hero-image {
  @media screen and (max-width: $small-mobile-size) {
    display: none;
    visibility: hidden;
  }

  @media screen and (min-width: $small-mobile-size) and (max-width: $mobile-size) {
    max-width: 80%;
    margin-top: 1em;
  }
}

.hero-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  z-index: 1;
}

.greeting-container {
  background: white;
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  display: flex;
  margin: 1em;

  @media screen and (max-width: $small-mobile-size) {
    width: 100%;
  }

  @media screen and (min-width: $small-mobile-size) and (max-width: $mobile-size) {
    width: 80%;
  }

  @media screen and (max-width: $mobile-size) {
    align-items: center;
    flex-direction: column;
  }

  @media screen and (min-width: $desktop-size) {
    flex-direction: row;
    width: 100%;
  }

  .form-container {
    display: flex;
    flex: 1;
    justify-content: center;
    padding: 1.5em;

    .form-title {
      font-size: 1.5em;
      margin: .5em 0;
      text-transform: uppercase;
    }
  }

  .sign-in {
    flex-direction: column;
    text-align: center;

    @media screen and (max-width: $mobile-size) {
      padding-bottom: 2em;
      width: 100%;
    }

    @media screen and (min-width: $desktop-size) {
      padding-right: 3em;
    }

    .form-title {
      color: #333;
    }
  }

  .sign-up {
    align-items: center;
    background: linear-gradient(153deg,
    rgba(50,53,255,1) 0%,
    rgba(70,100,255,1) 31%,
    rgba(99,170,255,1) 74%,
    rgba(121,221,255,1) 100%);
    flex-direction: column;
    justify-content: space-between;
    max-width: 400px;

    @media screen and (max-width: $mobile-size) {
      max-height: 230px;
      padding-top: 4em;
      width: 100%;
    }

    @media screen and (min-width: $desktop-size) {
      padding-left: 3em;
      width: 100%;
    }

    .form-title {
      color: white;
      font-weight: 300;
    }

    h2 {
      color: white;
      font-style: italic;
      text-align: center;
      font-weight: 100;
      line-height: 1.5em;

      @media screen and (max-width: $mobile-size) {
        display: none;
        visibility: hidden;
      }
    }

    p {
      color: white;
      margin: 1em 0 0;
      opacity: 1;
      padding: 0;
      text-align: center;
    }

    .signup-actions {
      margin-top: 1em;

      button {
        background: #F3E15E;
        border-radius: 3px;
        color: #333;
        text-transform: none;
      }
    }
  }

  @media screen and (max-width: 450px) {
    flex-direction: column;
  }
}

.vertical-divide {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  .divider-content {
    align-items: center;
    background: white;
    border-radius: 50px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    color: #666;
    display: flex;
    flex-direction: column;
    height: 50px;
    justify-content: center;
    left: -25px;
    padding: 1em;
    position: absolute;
    width: 50px;
    z-index: 1;
  }
}

.md-field {
  margin-bottom: .5em;
}

.call-to-action {
  background: linear-gradient(153deg,
    rgba(50,53,255,1) 0%,
    rgba(70,100,255,1) 31%,
    rgba(99,170,255,1) 74%,
    rgba(121,221,255,1) 100%);
  color: white !important;
  font-weight: 300;
  letter-spacing: 1px;
  text-transform: capitalize;

  @media screen and (max-width: $mobile-size) {
    margin: 2em 0;
  }
}

.primary-button {
    background: #79ddff;
    border-radius: 3px;
    color: #333;
    margin-top: 2em;
    text-transform: none;
}
</style>


<script>
import jwt_decode from 'jwt-decode'
import { mapGetters } from 'vuex'

export default {
    name: 'HomePage',
    data () {
      return {
        errors: false,
        sending: false,
        form: {
          username: null,
          password: null
        },
        showSignInDialog: false,
        showSignUpDialog: false,
      }
    },
    computed: {
      ...mapGetters([
        'clientCase'
      ])
    },
    methods: {
      signIn () {
        if (username.length === 0 || password.length === 0) {
          this.errors = true;
          return;
        }
        this.$http.post(`${process.env.VUE_APP_API_URL}/login`, {
          username: this.form.username,
          password: this.form.password
        }).then(response => {
          let token = jwt_decode(response.data.accessToken)
          this.$user.logIn(response.data.accessToken, token.roles[0])
          this.$http.setAuthHeaders();

          if (token.roles.includes('lawyer')) {
            this.$router.push({name: 'lawyer.cases.index'})
          }

          let caseId = token.case.id

          this.$http.get(`${process.env.VUE_APP_API_URL}/cases/${caseId}`).then((response) => {
            this.$store.commit('addClientCase', response.data);
            this.$router.push({name: 'cases.show', params: {id: this.$store.getters.clientCase.id}})
          })
        }).catch(error => this.errors = error)
      }
    }
}
</script>